<template>
<div>
  <div class="card-header text-center border-bottom-0">
    <h1 class="h4">{{ $t("design.forms") }}</h1>
  </div>
  <div class="card-body grid-kernel system_colors">
    <div class="form form-lines">
      <b-form-group id="Radio"
        horizontal
        :label-cols="3"
        label-size="Default"
        label="Button Radio:">
        <b-row>
          <b-col lg="4">
            <radio
            label="Radio"
            name="test"
            ref="radio"></radio>
          </b-col>
          <b-col lg="4">
            <radio
            label="Radio 2"
            name="test"
            ref="radio2"></radio>
          </b-col>
        </b-row>
      </b-form-group>
      <b-form-group id="Checkbox"
        horizontal
        :label-cols="3"
        label-size="Default"
        label="Checkbox:">
        <b-row>
          <b-col lg="4">
            <checkBox
            label="Check"
            ref="chbx"
            checked="value"></checkBox>
          </b-col>
          <b-col lg="4">
            <checkBox
            label="Check 2"
            ref="chbx"
            checked="value"></checkBox>
          </b-col>
        </b-row>
      </b-form-group>
      <b-form-group id="Buttons"
        horizontal
        :label-cols="3"
        label-size="Default"
        label="Main buttons:">
        <b-btn variant="primary">primary</b-btn>
        <b-btn variant="outline-primary">outline-primary</b-btn>
        <b-btn variant="secondary">secondary</b-btn>
        <b-btn variant="outline-primary">outline-secondary</b-btn>
      </b-form-group>
      <b-form-group id="Buttons"
        horizontal
        :label-cols="3"
        label-size="Default"
        label="State buttons:">
        <b-btn variant="info">info</b-btn>
        <b-btn variant="outline-info">outline-info</b-btn>
        <b-btn variant="success">success</b-btn>
        <b-btn variant="outline-success">outline-success</b-btn>
        <b-btn variant="danger">danger</b-btn>
        <b-btn variant="outline-danger">outline-danger</b-btn>
      </b-form-group>
    </div>
    <b-row class="mt-4">
      <b-col lg="6">
        <h5 class="mb-4 border-bottom pb-2">Form example</h5>
        <b-form-group
          id="fieldset1"
          label="Name"
          label-for="input1">
          <b-form-input id="input1"></b-form-input>
        </b-form-group>
        <b-form-group
          id="fieldset2"
          label="Email:"
          label-for="input2">
        <b-form-input id="input2" type="email"></b-form-input>
        </b-form-group>
        <b-row>
          <b-col lg="6">
            <b-form-group
              id="fieldset3"
              label="Password:"
              label-for="input3">
            <b-form-input id="input3" type="password"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col lg="6">
            <b-form-group
              id="fieldset4"
              label="Confirm password:"
              label-for="input4">
            <b-form-input id="input4" type="password"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
      </b-col>
      <b-col lg="6">
        <h5 class="mb-4 border-bottom pb-2">Form example messages</h5>
        <b-form-group
          :class="{feedback : showValidation}"
          id="fieldset1a"
          label="Name"
          label-for="input1a">
          <b-form-input id="input1a"></b-form-input>
          <p v-show="showValidation" class="alert alert-danger feedback-message">
            {{ $t('validation.input.special_characters')}}
          </p>
        </b-form-group>
        <b-form-group
          :class="{feedback : showValidation}"
          id="fieldset2a"
          label="Email:"
          label-for="input2a">
          <b-form-input id="input2a" type="email"></b-form-input>
          <p v-show="showValidation" class="alert alert-danger feedback-message">
            {{ $t('validation.input.email')}}
          </p>
        </b-form-group>
        <b-row>
          <b-col lg="6">
            <b-form-group
              id="fieldset3a"
              label="Password:"
              label-for="input3a">
            <b-form-input id="input3a" type="password"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col lg="6">
            <b-form-group
              :class="{feedback : showValidation}"
              id="fieldset4a"
              label="Confirm password:"
              label-for="input4a">
            <b-form-input id="input4a" type="password"></b-form-input>
            <transition name="slide-down">
              <p v-show="showValidation" class="alert alert-danger feedback-message">
                {{ $t('validation.input.password_confirm')}}
              </p>
            </transition>
            </b-form-group>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</div>
</template>

<style lang="scss" scoped="true">
  @import 'src/assets/styles/libs.scss';
</style>

<script>
import checkBox from '@/components/Modules/Misc/checkBox';
import radio from '@/components/Modules/Misc/Radio';
export default {
  name: 'Forms',
  components: {
    checkBox,
    radio
  },
  data: function () {
    return {
      showValidation: true
    };
  },
  methods: {

  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/Styles/Forms.vue